// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat[data-v-bdc8bebe]{display:flex;flex-direction:column-reverse}", "",{"version":3,"sources":["webpack://./resources/js/chat/components/Chat.vue"],"names":[],"mappings":"AACA,uBACE,YAAA,CACA,6BAAF","sourcesContent":["\n.chat {\n  display: flex;\n  flex-direction: column-reverse;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
